import { useTranslation } from 'react-i18next';
import { MANAGE_TABS, type ManageTabId } from './manageTabs';

type ManageTabBarProps = {
  value: ManageTabId;
  onChange: (tab: ManageTabId) => void;
  /** Emphasize Connect when the display still needs a TV. */
  connectAttention?: boolean;
};

/** Content / Connect / Settings — same IA on mobile and desktop. */
export function ManageTabBar({ value, onChange, connectAttention = false }: ManageTabBarProps) {
  const { t } = useTranslation('displays');
  return (
    <div
      className="flex gap-1 rounded-[12px] border p-1"
      style={{ background: 'var(--gs-panel2)', borderColor: 'var(--gs-line)' }}
      role="tablist"
      aria-label={t('manage.tabs.aria')}
    >
      {MANAGE_TABS.map((tab) => {
        const selected = value === tab.id;
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={selected}
            onClick={() => onChange(tab.id)}
            className="min-w-0 flex-1 rounded-[10px] px-2 py-2.5 text-[13px] font-bold sm:px-3 sm:text-[14px]"
            style={{
              color: selected ? 'var(--gs-ink)' : 'var(--gs-muted)',
              background: selected ? 'var(--gs-panel)' : 'transparent',
              boxShadow: selected
                ? '0 1px 2px color-mix(in srgb, #0a0a0b 8%, transparent)'
                : undefined,
            }}
          >
            {t(`manage.tabs.${tab.id}`)}
            {tab.id === 'connect' && connectAttention ? (
              <span
                className="ms-1 inline-block h-1.5 w-1.5 rounded-full align-middle"
                style={{ background: 'var(--gs-warn)' }}
                aria-hidden
              />
            ) : null}
          </button>
        );
      })}
    </div>
  );
}
